import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card border-0 box-shadow border-radius-10 mb-4 transaction browser-stats",
  style: {"height":"32vh","overflow-y":"auto"}
}
const _hoisted_2 = { class: "card-body p-4 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "ps-0 mb-0 list-unstyled",
  style: {"height":"100%","overflow-y":"auto"}
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "ms-3 fs-14 fw-medium text-body mb-0" }
const _hoisted_6 = { class: "fw-medium fs-14 text-body" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"20vh"}
}

import { useDashboardStore } from '@/stores/dashboard'
import { storeToRefs } from "pinia"


export default /*@__PURE__*/_defineComponent({
  __name: 'AgencySummary',
  setup(__props) {

const { agencyReceiptCount } = storeToRefs(useDashboardStore())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-title d-flex justify-content-between align-items-center mb-4" }, [
        _createElementVNode("h3", { class: "fw-medium fs-18 mb-0" }, "Agency Stats")
      ], -1)),
      (!!_unref(agencyReceiptCount).length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agencyReceiptCount), (agency) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "d-flex align-items-center justify-content-between border-bottom border-color pb-3 mb-3",
                key: agency.agencyName
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h4", _hoisted_5, _toDisplayString(agency.agencyName), 1)
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(agency.receiptCount), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h6", null, "Receipts have not been requested yet.", -1)
          ]))]))
    ])
  ]))
}
}

})